export default __webpack_public_path__ + "static/media/blog-33-image-3.9d786c6a.jpg";